import React from "react"

const HeroHead = ({ children }) => <div className="hero-head">{children}</div>

export default HeroHead
